import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = { class: "loading-content" }
const _hoisted_3 = { class: "loading-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.loadingText), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}